/* unplugin-vue-components disabled */import script from "./BaseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDetails.vue?vue&type=script&setup=true&lang=js"

import "./BaseDetails.vue?vue&type=style&index=0&id=17bcbb99&lang=scss"

const __exports__ = script;

export default __exports__